<template>
  <div class="flex text1 step-box mb30">
    <div class="item flex-1" @click="stepJump(1)">
      <img
        v-if="showIndex === 1"
        class="img-box"
        src="@/assets/images/img34_active.png"
        alt=""
      />
      <img v-else class="img-box" src="@/assets/images/img34.png" alt="" />
      <div>1.填写报名信息</div>
    </div>
    <div class="flex-1 item" @click="stepJump(2)">
      <!-- <div class="line left50"></div>
        <div class="line right50"></div> -->
      <img
        v-if="showIndex === 2"
        class="img-box item"
        src="@/assets/images/img32_active.png"
        alt=""
      />
      <img v-else class="img-box" src="@/assets/images/img32.png" alt="" />
      <div>2.上传工作室建设方案及实录视频</div>
    </div>
    <div class="flex-1 item" @click="stepJump(3)">
      <img
        v-if="showIndex === 3"
        class="img-box"
        src="@/assets/images/step-peo-active.png"
        alt=""
      />
      <img v-else class="img-box" src="@/assets/images/step-peo.png" alt="" />
      <div>3.团队人员1</div>
    </div>
    <div class="flex-1 item" @click="stepJump(4)">
      <img
        v-if="showIndex === 4"
        class="img-box"
        src="@/assets/images/step-peo-active.png"
        alt=""
      />
      <img v-else class="img-box" src="@/assets/images/step-peo.png" alt="" />
      <div>4.团队人员2</div>
    </div>
    <div class="flex-1 item" @click="stepJump(5)">
      <img
        v-if="showIndex === 5"
        class="img-box"
        src="@/assets/images/step-peo-active.png"
        alt=""
      />
      <img v-else class="img-box" src="@/assets/images/step-peo.png" alt="" />
      <div>5.团队人员3</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    showIndex: Number,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    stepJump(type) {
      this.$emit("stepJump", type);
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  text-align: center;
  position: relative;
  &::after {
    content: "";
    display: block;
    height: 1px;
    width: 50%;
    background: #e3e3e3;
    position: absolute;
    top: 27px;
    left: calc(50% + 60px);
  }
}
.item:last-child {
  &::after {
    display: none;
  }
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb30 {
  margin-bottom: 20px;
}
.step-box {
  padding-bottom: 10px;
}
.img-box {
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-bottom: 16px;
}

// .line {
//   position: absolute;
//   top: 28%;
//   width: 240px;
//   height: 1px;
//   background: #e3e3e3;
// }
// .left50 {
//   left: 68%;
// }
// .right50 {
//   right: 68%;
// }
// .main-box-line {
//   position: relative;
// }
</style>
